import styled from 'styled-components'

import {
  QUIZ_DIAGNOSTICS_BOOK_TITLE_OFFSET,
  QUIZ_DIAGNOSTICS_BOOK_TITLE_SLOT_HEIGHT
} from '../utils/quizDiagnosticsBarLayout'

const QuizDiagnosticsBookTitle = styled.div`
  flex-shrink: 0;
  width: 100%;
  min-height: ${QUIZ_DIAGNOSTICS_BOOK_TITLE_SLOT_HEIGHT}px;
  padding-top: ${QUIZ_DIAGNOSTICS_BOOK_TITLE_OFFSET}px;
  box-sizing: border-box;
  font-family: Arial Black, Arial, sans-serif;
  font-size: 16px;
  font-weight: 900;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`

export default QuizDiagnosticsBookTitle
